import { queryClient } from "@/constants";
import { CLIENT_API } from "@/services/axios-client";
import { useNotificationStore } from "@/states/zustand/notification";
import { useMutation, useQuery } from "@tanstack/react-query";


export const useGetAllPayments = () => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: ['payments'],
        queryFn: () => CLIENT_API.getAllPayments()
    });

    return {
        data,
        isLoading,
        ...rest
    }
}

export const useAddNewPayment = () => {
    const { mutate, isPending, ...rest } = useMutation({
        mutationKey: ['addNewPayment'],
        mutationFn: (data: FormData) => CLIENT_API.addNewPayment(data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['payments']
            });

            useNotificationStore.getState().setNotification({
                type: 'success',
                message: 'Payment method added successfully'
            })
        },
        onError: (error: string) => {
            useNotificationStore.getState().setNotification({
                type: 'error',
                message: error || 'Failed to add payment method'
            })
        }
    });

    return {
        mutate,
        isMutating: isPending,
        ...rest
    }
};

export const useUpdatePayment = () => {
    const { mutate, isPending, ...rest } = useMutation({
        mutationKey: ['editPayment'],
        mutationFn: (payload: { id: number, data: FormData }) => CLIENT_API.updatePayment(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['payments']
            });
        },
        onError: (error: string) => {
            useNotificationStore.getState().setNotification({
                type: 'error',
                message: error || 'Failed to update payment method'
            })
        }
    })

    return {
        mutate,
        isMutating: isPending,
        ...rest
    }
}


export const useDeletePayment = () => {
    const { mutate, isPending, ...rest } = useMutation({
        mutationKey: ['deletePayment'],
        mutationFn: (id: number) => CLIENT_API.deletePayment(id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['payments'],
            });
            useNotificationStore.getState().setNotification({
                type: 'success',
                message: 'Payment method deleted successfully'
            })
        },
        onError: (error: string) => {
            useNotificationStore.getState().setNotification({
                type: 'error',
                message: error || 'Failed to delete payment method'
            })
        }
    });

    return {
        mutate,
        isMutating: isPending,
        ...rest
    }
};